<template>
  <div>

  <data-table
      title="Sites By Landord"
      table-ref="landlordstable2"
      :url="'report/property/renewals/' + this.rowData.id"
      :show-search="false"
      sort-field="siteName"
      search-placeholder="Search Site Name..."
      :fields="fields"
      track-by="id"
      detail-component="property-details"
  />

</div>
</template>

<script>
import Vue from 'vue'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import PropertyDetails from '@/components/property/PropertyDetails'

Vue.component('property-details', PropertyDetails)

export default {
  mixins: [DateMixins, NumberMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },

  methods: {
    formatExpiry (value) {
      let val = value

      if (value) {
        if (this.isNumber(value)) {

          if (value > 0) {
            let color = 'success'

            if (value > 0 && value <= 2) {
              color = 'warning'
            }

            if (value > 3 && value <= 6) {
              color = 'primary'
            }

            val = '<span class="text-' + color + '">Renews in <b>' + this.formatInteger(value) + '</b> month' + (val > 1 ? 's' : '') + '</span>'

          } else {

            val = Math.abs(value)
            val = '<span class="text-danger">Expired <b>' + Math.abs(this.formatInteger(value)) + '</b> month' + (val > 1 ? 's' : '') + '</span>'

          }
        }
      }

      return val
    }

  },

  data () {
    return {
      stats: this.getStats(),
      landowners: [],
      fields: [
        {
          name: '__sequence',
          title: '#'
        },
        {
          name: 'siteId',
          title: 'Site ID',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'siteName',
          title: 'Site Name'
        },
        {
          name: 'period',
          title: 'Period',
          titleClass: 'hidden-lg-and-down',
          dataClass: 'hidden-lg-and-down'
        },
        {
          name: 'monthsToExpiry',
          title: 'Expiry',
          callback: this.formatExpiry
        },
        {
          name: 'avgAmount',
          title: 'Avg. Rental',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatNumber
        },
        {
          name: 'totalAmount',
          title: 'Total Rental',
          callback: this.formatNumber
        },
        {
          name: 'totalDeposit',
          title: 'Total Deposit',
          titleClass: 'hidden-lg-and-down',
          dataClass: 'hidden-lg-and-down',
          callback: this.formatNumber
        }
      ]
    }
  }
}
</script>

<style>
.dash-heading {
  font-size: 3em;
  color: lightgrey;
  padding-top: 0.852em;
  margin-bottom: 0.528em;
  border-bottom: 1px solid lightgrey}
</style>



// WEBPACK FOOTER //
// PropertyLandlordDetail.vue?161ac9d7